import React from 'react';
import ScreenSection from '../screen-section/ScreenSection';
import SectionTitle from '../section-title/SectionTitle';
import ContentContainer from '../content-container/ContentContainer';
import styles from './CooperationScreen.module.scss';
import Benefit from './Benefit';

import image1 from './infographic-icon-1.svg';
import image2 from './infographic-icon-2.svg';
import image3 from './infographic-icon-3.svg';

const CooperationScreen = ({ id }) => (
  <ScreenSection theme="light" id={id}>
    <div className={styles.root}>
      <div className={styles.centered}>
        <ContentContainer width="narrow">
          <SectionTitle>
            Benefits of
            <br />
            cooperation
          </SectionTitle>

          <div className={styles.benefits}>
            <div className={styles.benefitGrid}>
              <div className={styles.benefitHolder}>
                <Benefit
                  icon={image1}
                  title={
                    <>
                      Experienced
                      <br />
                      Partner
                    </>
                  }
                  description={<>Statistics based on more than 30 million ads</>}
                />
              </div>
              <div className={styles.benefitHolder}>
                <Benefit
                  icon={image2}
                  title={
                    <>
                      Actual
                      <br />
                      information
                    </>
                  }
                  description="Guaranteed regular data updates"
                />
              </div>
              <div className={styles.benefitHolder}>
                <Benefit
                  icon={image3}
                  title={
                    <>
                      Absolutely
                      <br />
                      free!
                    </>
                  }
                  description=";)"
                />
              </div>
            </div>
          </div>
        </ContentContainer>
      </div>
    </div>
  </ScreenSection>
);

export default CooperationScreen;
